import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Parlament.css';
import BackArrow from '../../BackArrow'; // Importiere die BackArrow-Komponente

function Parlament() {
  const navigate = useNavigate();
  
  const handleZeltsprecherClick = () => {
    navigate('/jobs/zeltsprecher');
  };

  const handlePabrikaClick = () => {
    navigate('/parlament/pabrika');
  };

  const handleParlamentskinderClick = () => {
    navigate('/parlament/kinder');
  };


  const handleAntraegeClick = () => {
    navigate('/parlament/antraege');
  };

  const handleAusschuessClick = () => {
    navigate('/parlament/ausschuesse');
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  const bereich = getCookie('Bereich');
  
  return (
    <div>
      <div className="page-header">
        <BackArrow to="/" />
        <h1>Parlament</h1>
      </div>
      {/* Anträge – für alle sichtbar */}
      <button className={`parlamentbutton bereich_button ${bereich ? bereich.replace(/[^a-zA-Z0-9]/g, '-') : ''}`} onClick={handleAntraegeClick}>Anträge</button>
      <button className={`parlamentbutton bereich_button ${bereich ? bereich.replace(/[^a-zA-Z0-9]/g, '-') : ''}`} onClick={handlePabrikaClick}>Pabrika-Antrag stellen</button>
      {bereich === 'Parlament' && (
        <button className={`parlamentbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleParlamentskinderClick}>Zeltsprecher*innen</button>
      )}
      {bereich === 'Parlament' && (
        <button className={`parlamentbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleAusschuessClick}>Ausschüsse</button>
      )}
      {bereich === 'Zeltbetreuung' && (
        <button className={`parlamentbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleZeltsprecherClick}>Zeltsprecher*in eintragen</button>
      )}
    </div>
  );
}

export default Parlament;
